import { $log, $q } from '../helpers/angular-migration-helpers'
import XhrService from './xhrservice.coffee'
import TransferFactoryService from './transferfactoryservice.coffee'
import AnalyticsService from './analyticsservice.coffee'

transferServers = {}

getTransferDetails = (call, shortUrl, params = {}, dfd) ->
  dfd ?= $q.defer()

  # Check if a specific region is listed for this transfer
  transferRegion = transferServers[shortUrl]

  # Add the short-url to the params
  params.shortUrl = shortUrl

  # Check if we need to redirect this transfer
  XhrService.get transferRegion, call, params, null, !!transferRegion
  .then (data) ->
    redirectRegion = data.redirectRegion
    if redirectRegion
      transferServers[shortUrl] = redirectRegion
      getTransferDetails call, shortUrl, params, dfd
    else
      dfd.resolve TransferFactoryService.getOrCreateTransfer data
  .catch (err) ->
    dfd.reject err
  dfd.promise

export default
  getTransfers: (limit, nextToken) ->
    dfd = $q.defer()

    # Obtain the transfers
    params = {}
    params.limit = limit if limit
    params.before = nextToken if nextToken

    XhrService.get null, 'history/timeline', params
    .then (data) ->
      dfd.resolve
        nextToken: data.nextToken
        transfers: TransferFactoryService.getOrCreateTransfer transfer for transfer in data.result
    .catch (err) ->
      dfd.reject err
    dfd.promise

  getUploadDetails: (shortUrl, language) ->
    params = {}
    params.language = language if language
    getTransferDetails "history/upload", shortUrl, params

  getDownloadDetails: (shortUrl, getDetails, language) ->
    params = {}
    if getDetails
      params.perFilePendingStatus = true
    else
      params.summaryOnly = true
    params.language = language if language
    getTransferDetails "history/download", shortUrl, params

  requestReUpload: (transfer) ->
    dfd = $q.defer()
    XhrService.post null, 'requestReupload', shortUrl: transfer.id
    .then (data) ->
      dfd.resolve()
    .catch (err) ->
      dfd.reject err
    dfd.promise

  downloadTransfer: (transfer, keys) ->
    if keys
      # Obtain the keys (in text-form)
      textKeys = (keys.map (f) -> f.getKey()).join ','

    XhrService.post null, 'download/getToken',
      shortUrl: transfer.id
      keys: textKeys
    .then (data) ->
      # Determine the base URL
      url = "#{transfer.url}?downloadToken=#{data.downloadToken}"

      if keys
        # Determine the total download size
        totalDownloadSize = 0
        for key in keys
          if item = transfer.files[key] | transfer.folders[key]
            totalDownloadSize += item.getTotalFileSize()

        # Log what happens
        $log.log "Selective transfer download '#{transfer.id} (#{totalDownloadSize} bytes): #{textKeys}"
      else
        # Log what happens
        $log.log "Full transfer download '#{transfer.id} (#{transfer.getTotalFileSize()} bytes)"

      # Track the event
      AnalyticsService.dataLayerPush
        event: 'Download'
        downloadId: transfer.id

      # Log conversion (disabled for now)
      # AnalyticsService.adConversionTrack '957553998', 'jLl2CLv-tFYQzrrMyAM'

      # Redirect
      window.location = url
    .catch ->
      $log.error "Unable to download '#{transfer.id}"
